import {RowBlock} from 'Event/Marketplace/Block/RowBlock'

export const createRowBlock = (
  numColumns: RowBlock['numColumns'] = 1,
): RowBlock => ({
  type: 'Row',
  alignment: {
    vertical: 'start',
    horizontal: 'center',
  },
  numColumns,
  background: {
    image: '',
    color: '',
    opacity: 0,
    position: 'center center',
    repeat: 'none',
  },
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  border: {
    width: 0,
    color: '#FFFFFF',
    radius: 0,
  },
  minHeight: 0,
  blocks: {},
  content: {
    background: {
      image: '',
      color: '',
      opacity: 0,
      position: 'center center',
    },
    border: {
      width: 0,
      color: '#FFFFFF',
      radius: 0,
    },
  },
  visibility: 'all',
})
